/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "1.5.0",
  "gitBuildTime": "2026-05-06T20:15:35.790Z",
  "gitBuildVersion": "1.5.0",
  "gitCommitId": "9a28165",
  "gitCommitIdFull": "9a281652b58aac943aa7ba825ed49ef7546bbbda",
  "gitCommitTime": "2026-05-06T20:14:13.000Z",
  "version": "1.5.0-2026-05-06T20:14:13.000Z-(9a28165)"
};
